(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.agendasettings')
        .directive('colors', ColorsDirectiveFn);

    ColorsDirectiveFn.$inject = [];

    function ColorsDirectiveFn() {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/templates/colors.template.html',
            scope: {
                model: '=',
                colors: '='
            }

        };
        return directive;

        function link(scope, element, attrs) {           
        }
    }

})();